import { render, staticRenderFns } from "./dailyWelfare.vue?vue&type=template&id=1d75d8b0&"
import script from "./dailyWelfare.vue?vue&type=script&lang=js&"
export * from "./dailyWelfare.vue?vue&type=script&lang=js&"
import style0 from "./dailyWelfare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d75d8b0')) {
      api.createRecord('1d75d8b0', component.options)
    } else {
      api.reload('1d75d8b0', component.options)
    }
    module.hot.accept("./dailyWelfare.vue?vue&type=template&id=1d75d8b0&", function () {
      api.rerender('1d75d8b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reservation/dailyWelfare.vue"
export default component.exports